"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = exports.Radio = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _label = _interopRequireDefault(require("./label"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _classnames = _interopRequireDefault(require("classnames"));

var _radio = _interopRequireDefault(require("./radio.scss"));

var _textfield = _interopRequireDefault(require("./textfield.scss"));

var _field = require("./field");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Radio = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Radio, _Component);

  function Radio(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Radio);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Radio).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      checked: false
    });

    if (props.checked !== undefined) {
      _this.state.checked = props.checked;
    }

    return _this;
  }

  (0, _createClass2["default"])(Radio, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.checked !== undefined && prevProps.checked !== this.props.checked) {
        this.setState({
          checked: this.props.checked
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      var _this2 = this;

      return function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(_this2.props.value);
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _cx, _cx2;

      var id = this.props.id || (0, _field.makeIdString)();
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_radio["default"].Radio, this.props.classNames.wrapper)
      }, _react["default"].createElement("input", {
        type: "radio",
        onChange: this.onChange(this.props.value),
        name: this.props.name,
        value: this.props.value,
        disabled: this.props.disabled,
        checked: this.state.checked,
        id: id,
        className: (0, _classnames["default"])(_radio["default"].field, this.props.classNames.field, (_cx = {}, (0, _defineProperty2["default"])(_cx, _radio["default"].fieldInvalid, this.props.errorMessage), (0, _defineProperty2["default"])(_cx, _radio["default"].inputDisabled, this.props.disabled), (0, _defineProperty2["default"])(_cx, this.props.classNames.inputDisabled, this.props.disabled), _cx)),
        "aria-label": this.props.ariaLabel
      }), _react["default"].createElement(_label["default"], {
        className: (0, _classnames["default"])(_radio["default"].label, this.props.classNames.label, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, _radio["default"].disabled, this.props.disabled), (0, _defineProperty2["default"])(_cx2, _radio["default"].labelDisabled, this.props.disabled), (0, _defineProperty2["default"])(_cx2, this.props.classNames.labelDisabled, this.props.disabled), _cx2)),
        "for": id
      }, this.props.label), this.props.children);
    }
  }]);
  return Radio;
}(_react.Component);

exports.Radio = Radio;
Radio.propTypes = _objectSpread({}, _field.fieldPropTypes, {
  children: _propTypes["default"].node,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  classNames: _propTypes["default"].shape({
    wrapper: _propTypes["default"].string,
    field: _propTypes["default"].string,
    labelDisabled: _propTypes["default"].string,
    inputDisabled: _propTypes["default"].string,
    label: _propTypes["default"].string
  })
});
Radio.defaultProps = {
  checked: false,
  disabled: false,
  classNames: {}
};

var RadioGroup = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(RadioGroup, _Component2);

  function RadioGroup(props) {
    var _this3;

    (0, _classCallCheck2["default"])(this, RadioGroup);
    _this3 = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RadioGroup).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this3), "state", {
      selected: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this3), "onChange", function (value) {
      if (_this3.props.onChange) {
        _this3.props.onChange(value);
      } else {
        _this3.setState({
          selected: value
        });
      }
    });

    if (props.selected !== undefined) {
      _this3.state.selected = props.selected;
    }

    return _this3;
  }

  (0, _createClass2["default"])(RadioGroup, [{
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      return _react["default"].createElement(_errorMessage["default"], {
        message: this.props.errorMessage,
        className: (0, _classnames["default"])(_radio["default"].radioGroupErrorMessage, this.props.classNames.errorMessage)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selected !== undefined && prevProps.selected !== this.props.selected) {
        this.setState({
          selected: this.props.selected
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx4,
          _this4 = this;

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_radio["default"].RadioGroup, (0, _defineProperty2["default"])({}, _radio["default"].RadioGroupHorizontal, this.props.isHorizontal))
      }, _react["default"].createElement(_label["default"], {
        className: (0, _classnames["default"])(_radio["default"].groupLabel, this.props.classNames.groupLabel, (_cx4 = {}, (0, _defineProperty2["default"])(_cx4, _textfield["default"].errorLabel, this.props.errorMessage), (0, _defineProperty2["default"])(_cx4, _radio["default"].radioGroupLabelDisabled, this.props.disabled), (0, _defineProperty2["default"])(_cx4, this.props.classNames.disabled, this.props.disabled), _cx4))
      }, this.props.label), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_radio["default"].groupWrap, this.props.classNames.radioGroup, (0, _defineProperty2["default"])({}, _radio["default"].groupWrapHorizontal, this.props.isHorizontal))
      }, _react["default"].Children.map(this.props.children, function (child) {
        if (child === null) {
          return child;
        }

        return _react["default"].cloneElement(child, {
          name: _this4.props.name,
          onChange: _this4.onChange,
          checked: _this4.state.selected === child.props.value
        });
      }), this.props.errorMessage && this.renderErrorMessage()));
    }
  }]);
  return RadioGroup;
}(_react.Component);

exports.RadioGroup = RadioGroup;
RadioGroup.propTypes = _objectSpread({}, _field.fieldPropTypes, {
  children: _propTypes["default"].node,
  selected: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  classNames: _propTypes["default"].shape({
    radioGroup: _propTypes["default"].string,
    groupLabel: _propTypes["default"].string,
    errorMessage: _propTypes["default"].string,
    disabled: _propTypes["default"].string
  })
});
RadioGroup.defaultProps = {
  classNames: {},
  disabled: false
};